import img1 from '../../src/assets/images/Injection-molding-machine.png';
import img2 from '../../src/assets/images/Pet-beverage-filling-line.png';
import img3 from '../../src/assets/images/pet-preforn-mold.png';
import img4 from '../../src/assets/images/PET-material-lab-equipment.jpg'
import img5 from '../../src/assets/integratedplastics/IMH.jpg';
import img6 from '../../src/assets/images/caps-closures-mold.jpg';
import img7 from '../../src/assets/images/Medical-pharma-paxkaging-mold.jpg';
import img8 from '../../src/assets/images/machine/Packaging & Systems.jpg';


const servicesData = [
  {
    id: 1,
    title: "Injection Molding Machine",
    slug: "injection-molding-machine",
    shortDescription: "High-performance injection molding machines for precision manufacturing.",
    description: "Our advanced injection molding machines are designed for optimal performance and precision in plastic manufacturing. These machines feature state-of-the-art technology for efficient operation and consistent quality output.",
    image: img1,
    isFeatured: true,
    displayOrder: 1
  },
  {
    id: 2,
    title: "Beverage Filling Line",
    slug: "beverage-filling-line",
    shortDescription: "Complete beverage filling systems for efficient bottling operations.",
    description: "Our beverage filling lines provide end-to-end solutions for bottling operations. These systems are designed for high-speed production with precision filling capabilities for various types of beverages and container formats.",
    image: img2,
    isFeatured: true,
    displayOrder: 2
  },
  {
    id: 3,
    title: "PET Preform Molds",
    slug: "pet-preform-molds",
    shortDescription: "Precision-engineered molds for PET preform production.",
    description: "Our PET preform molds are precision-engineered to produce high-quality preforms with consistent wall thickness and weight distribution. These molds are designed for durability and long production runs while maintaining tight tolerances.",
    image: img3,
    isFeatured: true,
    displayOrder: 3
  },
  {
    id: 4,
    title: "Lab Equipment",
    slug: "lab-equipment",
    shortDescription: "Specialized laboratory equipment for material testing and quality control.",
    description: "Our laboratory equipment provides comprehensive testing capabilities for plastic materials and finished products. These systems enable rigorous quality control processes and material validation to ensure compliance with industry standards.",
    image: img4,
    isFeatured: true,
    displayOrder: 4
  },
  {
    id: 5,
    title: "Exclusive Applications",
    slug: "drying-dehumidification-system",
    shortDescription: "Integrated Plastics- Patented, recyclable plastic container solutions for market-ready products.",
    description: "Our drying and dehumidification systems ensure proper moisture removal from plastic materials before processing. These systems are designed for energy efficiency and precise control of drying parameters to optimize material properties.",
    image: img5,
    isFeatured: true,
    displayOrder: 5
  },
  {
    id: 6,
    title: "Caps & Closures Mold",
    slug: "caps-closures-mold",
    shortDescription: "Specialized molds for producing high-quality caps and closures.",
    description: "Our caps and closures molds are engineered for high-volume production with exceptional precision. These molds feature optimized cooling and ejection systems for maximum productivity while maintaining tight dimensional tolerances.",
    image: img6,
    isFeatured: true,
    displayOrder: 6
  },
  {
    id: 7,
    title: "Packaging Mold",
    slug: "packaging-mold",
    shortDescription: "Precision manufacturing molds for diverse packaging solutions.",
    description: "Our packaging molds are designed for producing high-quality containers and packaging components with exceptional precision and consistency. These molds feature advanced cooling systems and optimized flow paths to ensure consistent quality and maximum productivity for various packaging applications.",
    image: img7,
    isFeatured: true,
    displayOrder: 7
  },
  {
    id: 8,
    title: "Packaging-systems",
    slug: "packaging-systems",
    shortDescription: "High-quality colorants and performance additives for plastic products.",
    description: "Our premium liquid colorants and additives are formulated to enhance the appearance and performance of plastic products. These specialty materials provide consistent color dispersion, UV protection, and other functional properties while maintaining processing efficiency and end-product quality.",
    image: img8,
    isFeatured: true,
    displayOrder: 8
  }
];

export default servicesData;